import { useState, useEffect } from "react";
import { API_BASE_URL, getAuthHeaders } from "./api";

// The campus shown on reports/challans is the logged-in admin's assigned campus.
// GET /api/campuses already returns only the campuses assigned to the current
// admin (a superadmin gets all of them), so it is the authoritative source —
// not the student records, whose campus_name can differ or be unset.
//
// Returns:
//   ""             while loading / on failure / no campus
//   "<Campus>"     the single assigned campus (the normal admin case)
//   "All Campuses" when the user can see more than one (e.g. superadmin)
export const useAdminCampus = () => {
  const [campus, setCampus] = useState("");
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/campuses`, { headers: getAuthHeaders() });
        if (!res.ok) return;
        const data = await res.json();
        if (!alive || !Array.isArray(data)) return;
        const names = [...new Set(data.map(c => c?.name).filter(Boolean))];
        setCampus(names.length === 1 ? names[0] : names.length > 1 ? "All Campuses" : "");
      } catch { /* leave campus empty on failure */ }
    })();
    return () => { alive = false; };
  }, []);
  return campus;
};

export default useAdminCampus;
